import { isError } from "./isError"

function stringify(o: unknown) {
  return typeof o === "object" ? JSON.stringify(o) : String(o)
}

export function toError(o: unknown) {
  return isError(o) ? o : new Error(stringify(o))
}
